<div class="container mt-4">
  <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToHome()">Home</a><span class="separator">/</span></li>
      <li class="breadcrumb-item active"><a href="javascript:void(0)">Area Personale</a></li>
    </ol>
  </nav>
</div>
<div class="container px-4 my-4">
  <div class="row">
    <h1 class="text--left mb-4">
      Area personale
    </h1>
  </div>
  <div class="row">
    <div class="col-12 col-md-4">
      <div class="card-wrapper card-space">
        <div class=" card card-bg  card-big rounded shadow">
          <div class="card-body">
            <div class="d-flex align-items-center flex-wrap flex-sm-nowrap ">
              <h5 class="card-title ">
                Profilo
              </h5>
            </div>
            <a class="read-more" (click)="goToProfilo()">
                    <span class="text">
                        Vai alla Pagina
                    </span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="card-wrapper card-space">
        <div class=" card card-bg  card-big rounded shadow">
          <div class="card-body">
            <div class="d-flex align-items-center flex-wrap flex-sm-nowrap ">
              <h5 class="card-title ">
                Gestione Preferiti
              </h5>
            </div>
            <a class="read-more" (click)="goToPreferiti()">
                    <span class="text">
                        Vai alla Pagina
                    </span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="card-wrapper card-space">
        <div class=" card card-bg  card-big rounded shadow">
          <div class="card-body">
            <div class="d-flex align-items-center flex-wrap flex-sm-nowrap ">
              <h5 class="card-title ">
                Le mie pratiche
              </h5>
            </div>
            <a class="read-more" (click)="goToIstanze()">
                    <span class="text">
                        Vai alla Pagina
                    </span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <div class="card-wrapper card-space">
        <div class=" card card-bg  card-big rounded shadow">
          <div class="card-body">
            <div class="d-flex align-items-center flex-wrap flex-sm-nowrap ">
              <h5 class="card-title ">
                I miei appuntamenti
              </h5>
            </div>
            <a class="read-more" (click)="goToAppuntamenti()">
                    <span class="text">
                        Vai alla Pagina
                    </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
